module.exports = __webpack_public_path__ + "img/KSC04470.95dce50d.jpg";